import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const branchTerminalsWidget: DashboardWidgetConfiguration = {
  widgetId: "branch.terminals",
  name: "Terminal sales",
  description: "All outlet terminals and their paid sales in the last 30 days, including zero-sale terminals.",
  apps: [
    "configuration",
  ],
  template: "position",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "pos.terminal-sales",
      ...period(1),
      select: [
        {
          type: "field",
          field: "terminal_name",
          as: "terminal_name",
        },
        {
          type: "field",
          field: "terminal_code",
          as: "terminal_code",
        },
        {
          type: "field",
          field: "orders_30d",
          as: "orders_30d",
        },
        {
          type: "field",
          field: "sales_30d",
          as: "sales_30d",
        },
      ],
      order_by: [
        {
          ref: "terminal_name",
          direction: "asc",
        },
      ],
      limit: 20,
    },
  },
  inputs: {
    title: "Terminal sales",
    subtitle: "All outlet terminals and their paid sales in the last 30 days, including zero-sale terminals.",
    columns: [
      {
        key: "terminal_name",
        label: "Terminal",
      },
      {
        key: "terminal_code",
        label: "Code",
      },
      {
        key: "orders_30d",
        label: "Paid orders",
        align: "end",
        format: "number",
      },
      {
        key: "sales_30d",
        label: "Paid sales",
        align: "end",
        format: "currency",
      },
    ],
  },
  dummyData: {
    value: "Posted",
    rows: [],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 8,
    defaultWidth: 12,
    defaultHeight: 4,
  },
};
